// utls/HeadingH1.jsx
import clsx from "clsx";

const HeadingH1 = ({ children, className = "" }) => {
  return (
    <h1 className={clsx("custom-heading", className)}>
      {children}
    </h1>
  );
};

export default HeadingH1;
